export default __webpack_public_path__ + "static/media/974.297487e4.gif";